<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/3 mb-base">
      <h5 class="mb-6">Загрузка файла</h5>
      <slot name="form"></slot>
    </div>
    <div class="vx-col w-full lg:w-2/3" v-if="$slots.history">
      <h5 class="mb-6">История импорта</h5>
      <slot name="history"></slot>
    </div>
  </div>
</template>

<script>
const findParent = ( $el, componentName ) => {
  while ($el) {
    if ($el.$vnode.componentOptions.tag === componentName) return $el;
    $el = $el.$parent;
  }
  return null;
};

export default {
  name:    "ImportTab",
  data() {
    return {
      observer: null,
    };
  },
  methods: {
    updateSize() {
      const parent = findParent(this, 'vs-collapse-item');
      if (parent) parent.changeHeight();
    },
  },
  mounted() {
    const observer = new MutationObserver(() => {
      setTimeout(this.updateSize, 80);
    });

    observer.observe(this.$el, {
      attributes: true,
      childList:  true,
      subtree:    true,
    });
  },
  destroyed() {
    if (this.observer) this.observer.disconnect();
  },
};
</script>

<style scoped>

</style>
